var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.343 0c4.594 0 8.343 3.437 8.343 7.713 0 4.275-3.75 7.712-8.343 7.712a8.929 8.929 0 01-3.026-.523l-.136-.05-.087.023-.135.039-.348.107-.27.088-.32.107c-.4.134-.883.3-1.45.5l-.696.247c-.479.17-.948-.28-.808-.777l.23-.826c.121-.435.222-.806.303-1.113l.115-.448.042-.17.033-.14C.64 11.141 0 9.473 0 7.712 0 3.437 3.75 0 8.343 0zm0 1.275c-3.93 0-7.092 2.898-7.092 6.438 0 1.532.592 2.982 1.659 4.135a.587.587 0 01.174.446.936.936 0 01-.008.132 2.57 2.57 0 01-.036.208l-.008.041-.036.158-.082.337-.096.37-.065.247-.155.57.756-.264c1.453-.5 1.86-.588 2.116-.493l.14.055a7.69 7.69 0 002.733.495c3.93 0 7.091-2.898 7.091-6.437 0-3.54-3.16-6.438-7.091-6.438z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.086 5.634c0-.486.505-1.063 1.371-1.063s1.372.577 1.372 1.063c0 .326-.135.667-.79 1.228-.031.028-.066.056-.102.086-.445.374-1.166.978-1.166 2.08v.412a.686.686 0 101.372 0v-.411c0-.45.242-.656.769-1.108l.02-.018c.785-.672 1.268-1.36 1.268-2.269C11.2 4.19 9.863 3.2 8.457 3.2s-2.743.99-2.743 2.434v.103a.686.686 0 101.372 0v-.103zm1.352 6.709a.8.8 0 100-1.6.8.8 0 000 1.6z",
    fill: "#717171"
  })));
}

export default SvgNoQuestion;